var yy_request = require('../js/yunyin_request')

module.exports = {
  props: {
    show: {
      type: Boolean,
      required: true,
      twoWay: true,
    },
    fileForShare: Object,
  },

  data: function () {
    return {
      modalWidth: 600,
      title: "分享文件",
    }
  },

  methods: {
    onShare: function() {
      var sfile = this.fileForShare
      var ajax_data = {
        fid: sfile.id,
        anonymous: sfile.anonymous
      }
      if(sfile.shareName!="") {
        ajax_data.name = sfile.shareName
      }
      if(sfile.shareDesc!="") {
        ajax_data.detail = sfile.shareDesc
      }
      yy_request.rest_api({
        method: 'post',
        api: 'share/',
        data: ajax_data,
        opSuccess: function(info) {
          for(var i in sfile.shareTags) {
            postTag(sfile.shareTags[i],info.id)
          }
        },
      })
    },

    onEdit: function() {
      
    }
  },

  components: {
    'modal': require('./modal.vue'),
  }
}


function postTag(tag,sfileId) {
  yy_request.rest_api({
    method: 'post',
    api: 'tags/',
    data: {"name":tag},
    opSuccess: function(info) {
      associateTag(info.id,sfileId)
    },
  })  
}

function associateTag(tagId,sfileId) {
  yy_request.rest_api({
    method: 'post',
    api: 'tags/' + tagId,
    data: {"sid":sfileId},
    opSuccess: function(info) {
      console.log(info)
    },
  })  
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/share-modal.vue
// module id = 143
// module chunks = 0